import { Theme } from '@mui/system'
import { makeStyles } from '@mui/styles'
import { FONTS, SPACES } from 'src/constants'

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',

    [theme.breakpoints.down('tablet')]: {
      width: '100%',

      gap: '10px',
      borderRadius: 10,
    },

    [theme.breakpoints.up('tablet')]: {
      paddingBottom: SPACES.xxl,
      border: `1px solid ${theme.palette.custom.grey}`,
      borderRadius: 15,
    },
  },
  text: {
    [theme.breakpoints.down('tablet')]: {
      display: 'none',
    },
    [theme.breakpoints.up('tablet')]: {
      paddingLeft: SPACES.xxl,

      fontWeight: FONTS.WEIGHTS.medium,
      color: theme.palette.custom.grey2,
      marginBottom: SPACES.xxxs,
      fontSize: FONTS.SIZES.xs,
    },
  },
  mapWrapper: {
    [theme.breakpoints.down('tablet')]: {
      width: '100%',
    },

    [theme.breakpoints.up('tablet')]: {
      width: '100%',
      padding: '0px 20px',
    },
  },
  root: {
    width: '100%',
    height: 282,
    borderRadius: 22,
  },
  loader: {
    '&&': {
      width: '100%',
      flex: 1,

      borderRadius: 15,

      [theme.breakpoints.down('tablet')]: {
        height: 524,
      },

      [theme.breakpoints.up('tablet')]: {
        height: 588,
      },
    },
  },
}))

export default useStyles
